import { memo } from 'react';

import { YMInitializer } from 'react-yandex-metrika';

const YM_COUNTER_KEY = Number(window.envKeys.YM_AGENT_COUNTER_KEY);

export const WebAnalytic = memo(() => {
  return (
    <YMInitializer
      accounts={[Number(YM_COUNTER_KEY)]}
      options={{
        triggerEvent: true,
        childIframe: true,
        trackLinks: true,
        accurateTrackBounce: true,
        clickmap: true,
        webvisor: false,
        trustedDomains: ['https://pulse.rusrobots.ru/', 'https://pulse.insure'],
      }}
      version='2'
    />
  );
});
